import {React, createContext, useContext } from "react";
import { getHasLoginStatus } from "../utilities/account-service-utils";

export const UserSignedContext = createContext();

const UserContext = ({ children }) => {
    const userIsSigned = getHasLoginStatus();

    return (
        <UserSignedContext.Provider value={userIsSigned}>
            {children}
        </UserSignedContext.Provider>
    )
}

export default UserContext